/**
 * Created by tomers on 1/5/2015.
 *
 *************************************************************************************************
 **************************************** MULTISELECT INITIALIZE ****************************************
 *************************************************************************************************
 var multiselect = new Multiselect({
        container: $(), // the multiselect container
        permutation: Multiselect.PERMUTATION.FULL, // the permutation is a permutation from Multiselect.PERMUTATION Enum. the permutation responsible for the component width. default is FULL
        asyncFilter: false, // true for async list filtering. default is false. If you are using asyncFilter you should listen to "filter" event.
        asyncFilterMinChars: 3, // minimum num of chars before the component triggers the "filter" event. default is 3
        floating: true, // if the list within the multiselect component is floating or not (regardless if the list has "floating" class name). default is true
        items: [
            {
                id: 1,
                value: "Item 1",
                selected: true
            }
        ],
        selectedItems: [1] // array of the selected items ids - optional
        list: {
            // any List options you want to send to the List component of this Multiselect (without items and selectedItems)
            //  for example - newItem: {visible:true}
        },
        tagsContainer: {
            // any TagsContainer options you want to send to the TagsContainer component of this Multiselect (without items)
            //  for example - tagMaxWidth: "395px"
        }
 });
 *************************************************************************************************
 *************************************************************************************************
 *************************************************************************************************
 *
 *
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var Marionette = require("marionette");
    var Logger = require("logger");
    var _ = require("underscore");

    //Template
    var template = require("ui/multiselect/templates/multiselect.tmpl");

    //Components
    var TagsContainer = require("ui/tags-container/TagsContainer");
    var List = require("ui/list/List");
    var Loader = require("ui/loader/Loader");

    //Multiselect MVC
    var MultiselectModel = require("ui/multiselect/js/models/MultiselectModel");
    //</editor-fold>

    var PERMUTATION = {
        FULL: "perm-full",
        MEDIUM: "perm-medium",
        MEDIUM2: "perm-medium2",
        SELECTED_NUMBERS: "perm-selected-num"
    };

    var TRIGGERING = {
        FILTER: "filter",
        CREATE: "create",
        SELECT: "select",
        UNSELECT: "unselect",
        FOCUS: "focus"
    };

    var FLOATING_CLASS_NAME = "floating";

    var Multiselect = Marionette.ItemView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        className: "multiselect-component-container",
        template: template,
        ui: {
            tagsContainer: ".tags-container-container",
            list: ".list-container",
            loader: ".loader-container"
        },
        events: {
            "keydown .tags-container-container": "_onContainerKeydown",
        },
        withUIComponents: true,
        listShouldBeHideOnBlur: true,
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function(options) {
            this._initialize(options);
        },
        onRender: function() {
            this._onRender();
        },
        onClose: function() {
            this._onClose();
        },
        //</editor-fold>

        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        showLoader: function(show, isFullLoader) {
            this._showLoader(show, isFullLoader);
        },
        addItem: function(item) {
            this._addItem(item);
        },
        removeItem: function(itemId) {
            this._removeItem(itemId);
        },
        select: function(itemId) {
            this._select(itemId);
        },
        unselect: function(itemId) {
            this._unselect(itemId);
        },
        unselectAll: function() {
            this._unselectAll();
        },
        setItems: function(items) {
            this._setItems(items);
        },
        setFocus: function() {
            this._setFocus();
        },
        setBlur: function() {
            this._setBlur();
        },
        discardInput: function() {
            return this._discardInput();
        },
        getInputValue: function() {
            return this._getInputValue();
        },
        setInputValue: function(value) {
            this._setInputValue(value);
        },
        clearInputValue: function() {
            this._clearInputValue();
        },
        getSelectedItems: function() {
            return this._getSelectedItems();
        },
        setEnabled: function(enabled) {
            this._setEnabled(enabled);
        },
        setError: function(isError, errorMsg) {
            this._setError(isError, errorMsg);
        },
        setInlineError: function(isError) {
            this._setInlineError(isError);
        },
        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function (options) {
            this.logger = Logger.getLogger("Multiselect");
            this.logger.info("Initializing Multiselect", "Multiselect:_initialize", {options: options});

            this.comboId = _.uniqueId("combobox-");
            this.model = _initMultiselectModel(options);
            this.listOptions = _initListOptions(options);
            this.tagsContainerOptions = _initTagsContainerOptions(options);

            this.permutation = _.has(options, "permutation") ? options.permutation : PERMUTATION.FULL;
            this.container = options.container;
            this.showNumberOfSelected = options.showNumberOfSelected;
        },

        _onRender: function() {
            this.logger.info("Rendering Multiselect", "Multiselect:_onRender");

            this.$el.toggleClass(FLOATING_CLASS_NAME, this.model.isFloating());
            this.$el.addClass(this.permutation);
            this.ui.tagsContainer.attr("tabindex", "0");
            if (this.container) {
                this.container.append(this.$el);
            }

            this._createAndRenderList();
            this._createAndRenderTagsContainer();

            // a11y
            this.ui.tagsContainer.attr("aria-owns", this.comboId);

            this.ui.list.find(".list-group-items-container")
                .attr("id", this.comboId)
                .attr("role", "listbox")
                .attr("aria-multiselectable", true)
                .attr("tabindex", "0");

            this.ui.list.find(".list-item-container")
                .attr("tabindex", "-1")
                .attr("role", "option");

        },

        _createAndRenderList: function() {
            this.logger.info("Rendering Multiselect List", "Multiselect:_createAndRenderList");

            var listOptions = this.listOptions;
            listOptions.container = this.ui.list;

            var listEvents = {};
            listEvents[List.TRIGGERING.CLICK] = "_onListItemClick";

            this.logger.debug("Multiselect List Options", "Multiselect:_createAndRenderList", {options:listOptions, event:listEvents});
            this.uiComponents.host$.createAndRender("list", {
                type: List,
                options: listOptions,
                events: listEvents
            });
        },

        _createAndRenderTagsContainer: function() {
            this.logger.info("Rendering Multiselect TagsContainer", "Multiselect:_createAndRenderTagsContainer");

            var tagsContainerOptions = this.tagsContainerOptions;
            tagsContainerOptions.container = this.ui.tagsContainer;
            tagsContainerOptions.items = this._getSelectedItemsArrByList();

            var tagsContainerEvents = {};
            tagsContainerEvents[TagsContainer.TRIGGERING.FOCUS] = "_onTagsContainerFocus";
            tagsContainerEvents[TagsContainer.TRIGGERING.BLUR] = "_onTagsContainerBlur";
            tagsContainerEvents[TagsContainer.TRIGGERING.INPUT_CHANGE] = "_onTagsContainerInputChange";
            tagsContainerEvents[TagsContainer.TRIGGERING.INPUT_CREATE] = "_onTagsContainerInputCreate";
            tagsContainerEvents[TagsContainer.TRIGGERING.INPUT_ARROW] = "_onTagsContainerInputArrow";
            tagsContainerEvents[TagsContainer.TRIGGERING.TAG_REMOVE] = "_onTagsContainerTagRemove";

            this.logger.debug("Multiselect TagsContainer Options", "Multiselect:_createAndRenderTagsContainer", {options:tagsContainerOptions, event:tagsContainerEvents});
            this.uiComponents.host$.createAndRender("tagsContainer", {
                type: TagsContainer,
                options: tagsContainerOptions,
                events: tagsContainerEvents
            });

            if (this.showNumberOfSelected) {
                this.ui.tagsContainer.find('.tags-wrapper').hide();
                this.ui.tagsContainer.find('.tags-container-component').append(this._createValueContainer());
                this._updateValue();
            }
        },

        _createValueContainer: function () {
            var div = document.createElement('div');
            var span = document.createElement('span');
            div.className = 'multi-select-value-container';
            span.className = 'multi-select-value';
            div.appendChild(span);
            return div;
        },

        _updateValue: function() {
            var tagsContainer = this.uiComponents.tagsContainer;
            var text;

            if (tagsContainer.getItems().length === 1) {
                text = tagsContainer.getItems()[0].value;
            } else {
                text = tagsContainer.getItems().length + " selected";
            }

            this.ui.tagsContainer.find('.multi-select-value').text(text);
        },

        _onListItemClick: function(componentId, eventName, listItem) {
            var listItemId = listItem.id;
            this.listShouldBeHideOnBlur = false;

            this.logger.info("Multiselect List Item Click", "Multiselect:_onListItemClick", {listItemId:listItemId});

            if (listItem.id === List.NEW_ITEM_ID) {
                this._onListItemNewItemClick();
            }
            else if (listItem.id !== List.NO_ITEMS_ID) {
                if (listItem.selected) {
                    this._onListItemSelect(listItem);
                }
                else {
                    this._onListItemUnselect(listItem);
                }
            }
        },

        _onListItemSelect: function(listItem) {
            this.logger.debug("Multiselect List Item Select", "Multiselect:_onListItemSelect");

            this.uiComponents.tagsContainer.addItem(_mapListObjToTagsContainerObj(listItem));
            this.uiComponents.tagsContainer.clearInputValue();

            this.trigger(TRIGGERING.SELECT, listItem);

            if (this.showNumberOfSelected) {
                this._updateValue();
            }
        },
        _onListItemUnselect: function(listItem) {
            this.logger.debug("Multiselect List Item Unselect", "Multiselect:_onListItemUnselect");

            this.uiComponents.tagsContainer.removeItem(listItem.id);

            this.trigger(TRIGGERING.UNSELECT, listItem);

            if (this.showNumberOfSelected) {
                this._updateValue();
            }
        },
        _onListItemNewItemClick: function() {
            this.logger.debug("Multiselect List Item New", "Multiselect:_onListItemNewItemClick");

            var inputValue = this.uiComponents.tagsContainer.getInputValue();
            inputValue = (this.model.isTrim()) ? inputValue.trim() : inputValue;

            this.trigger(TRIGGERING.CREATE, {value: inputValue});
        },

        _onContainerKeydown: function(e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                if (this._isListShown()) {
                    this.uiComponents.tagsContainer.setBlur();
                } else {
                    this.uiComponents.tagsContainer.setFocus();
                }
                e.preventDefault();
            } else if (e.keyCode === 9) {
                this.uiComponents.tagsContainer.setBlur();
            }
        },

        _onTagsContainerFocus: function(componentId, eventName, obj) {
            this.logger.info("Multiselect TagsContainer Focus", "Multiselect:_onTagsContainerFocus");

            var value = (this.model.isTrim()) ? obj.value.trim() : obj.value;

            if (this.model.isAsyncFilter()) {
                this._asyncFilterList(value);
            }
            else {
                this._filterList(value);
                var needToScroll = !this._isListShown();
                this._showList(true);
                this.uiComponents.list.clearActiveItem();
                if (needToScroll) {
                    this.uiComponents.list.scrollTop(0);
                }
            }
            this.trigger(TRIGGERING.FOCUS);
        },

        _onTagsContainerBlur: function() {
            this.logger.info("Multiselect TagsContainer Blur", "Multiselect:_onTagsContainerBlur");

            if (this.listShouldBeHideOnBlur) {
                this._filterList("");
                this._showList(false);
            }
            this.listShouldBeHideOnBlur = true;
        },

        _onTagsContainerInputChange: function(componentId, eventName, obj) {
            var value = (this.model.isTrim()) ? obj.value.trim() : obj.value;
            this.logger.info("Multiselect TagsContainer Input Change", "Multiselect:_onTagsContainerInputChange", {value:value});

            if (this.model.isAsyncFilter()) {
                this._asyncFilterList(value);
            }
            else {
                this._filterList(value);
            }

            // this.ui.list.find(".list-item-container.active").attr("aria-live", "assertive");
            // this.ui.list.find(".list-item-container").not(".active").removeAttr("aria-live");
            // this.ui.list.find(".list-item-container").attr("tabindex", "-1").attr("role", "option");
            // this.ui.list.find(".list-group-items-container").attr("id", this.comboId);
            // this.ui.tagsContainer.attr("aria-owns", this.comboId);
            // this.ui.tagsContainer.find(".tag-input").attr("aria-controls", this.comboId);
            // this.ui.tagsContainer.find(".tag-input").attr("aria-activedescendant", this.ui.list.find(".list-item-container.active").attr("id"));
        },

        _onTagsContainerInputCreate: function (componentId, eventName, obj) {
            var listItem;
            var value = (this.model.isTrim()) ? obj.value.trim() : obj.value;
            this.logger.info("Multiselect TagsContainer Input Create", "Multiselect:_onTagsContainerInputCreate", {value:value});

            if (this.model.isAsyncFilter() && value.length < this.model.getAsyncFilterMinChars()) { // if we are on async filter and the value is less than minimum - ignore
                return;
            }

            if (this.uiComponents.list.hasActiveItem()) {
                this.logger.debug("Multiselect - 'Create' by List", "Multiselect:_onTagsContainerInputCreate");
                var id = this.uiComponents.list.getActiveItem();
                listItem = this._getListItemById(id);
                if (!_.isEmpty(listItem)) {
                    this.logger.debug("Multiselect - valid selected item", "Multiselect:_onTagsContainerInputCreate", {listItem:listItem});
                    if (!listItem.selected) {
                        this.uiComponents.tagsContainer.addItem(_mapListObjToTagsContainerObj(listItem));
                        this.uiComponents.list.select(listItem.id);
                        this.uiComponents.tagsContainer.clearInputValue();
                        this.uiComponents.tagsContainer.setFocus();

                        this.trigger(TRIGGERING.SELECT, listItem);
                    }
                    else {
                        this.uiComponents.tagsContainer.removeItem(listItem.id);
                        this.uiComponents.list.unselect(listItem.id);
                        this.uiComponents.tagsContainer.setFocus();

                        this.trigger(TRIGGERING.UNSELECT, listItem);
                    }
                }
                else if(id === List.NEW_ITEM_ID) {
                    this.logger.debug("Multiselect - selected item is 'create new item'", "Multiselect:_onTagsContainerInputCreate");
                    this.trigger(TRIGGERING.CREATE, {value: value});
                }
            }
            else {
                this.logger.debug("Multiselect - 'Create' by TagsContainer", "Multiselect:_onTagsContainerInputCreate");
                listItem = this._getListItemByValue(value);

                if (!_.isEmpty(listItem)) {
                    this.logger.debug("Multiselect - valid selected item", "Multiselect:_onTagsContainerInputCreate", {listItem:listItem});
                    if (!listItem.selected && listItem.enabled) {
                        this.uiComponents.tagsContainer.addItem(_mapListObjToTagsContainerObj(listItem));
                        this.uiComponents.list.select(listItem.id);
                        this.uiComponents.tagsContainer.clearInputValue();
                        this.uiComponents.tagsContainer.setFocus();

                        this.trigger(TRIGGERING.SELECT, listItem);
                    }
                    else {
                        // todo: there is already tag with this value selected. what should we do? currently doing nothing
                    }
                }
                else if(!_.isEmpty(value)) {
                    this.logger.debug("Multiselect - create new item", "Multiselect:_onTagsContainerInputCreate");
                    this.trigger(TRIGGERING.CREATE, {value: value});
                }
            }
        },

        _onTagsContainerInputArrow: function(componentId, eventName, obj) {
            this.logger.info("Multiselect TagsContainer Input Arrow", "Multiselect:_onTagsContainerInputArrow");
            this.uiComponents.list.moveSelection(obj);
        },

        _onTagsContainerTagRemove: function(componentId, eventName, obj) {
            var value = (this.model.isTrim()) ? obj.value.trim() : obj.value;
            this.logger.info("Multiselect TagsContainer Tag Remove", "Multiselect:_onTagsContainerTagRemove", {value:value});

            var listItem = this._getListItemByValue(value);
            if (!_.isEmpty(listItem)) {
                this.uiComponents.list.unselect(listItem.id);

                this.trigger(TRIGGERING.UNSELECT, listItem);
            }
        },

        _asyncFilterList: function(value) {
            this.logger.debug("Multiselect async filter", "Multiselect:_asyncFilterList", {value:value});

            if (value.length >= this.model.getAsyncFilterMinChars()) {
                if (value !== this.model.getFilterValue()) {
                    this._showLoader(true);
                    this.trigger(TRIGGERING.FILTER, {value:value, success: _.bind(this._onAsyncFilterSuccess,this)});
                }
                else {
                    this._showList(true);
                }
            }
            else {
                this._showList(false);
            }

            this.model.setFilterValue(value);
        },

        _onAsyncFilterSuccess: function(listItems) {
            this.logger.info("Multiselect async filter success callback", "Multiselect:_onAsyncFilterSuccess", {value:listItems});

            var currentSelectedIds = this._getSelectedItems();

            _.each(listItems, function(listItem, index) {
                if (_.indexOf(currentSelectedIds, listItem.id) > -1) {
                    listItems[index].selected = true;
                }
            });

            this.uiComponents.list.setItems(listItems, {filter:this.model.getFilterValue()});

            this._showList(true);
            this._showLoader(false);
        },

        _showLoader: function(show, isFullLoader) {
            this.logger.info("Multiselect show loader", "Multiselect:_showLoader", {show:show});

            if (this.loader) {
                this.loader.close();
            }

            if (this.ui.loader && _.isFunction(this.ui.loader.toggleClass)) {
                this.ui.loader.toggleClass("hide", !show);
                if (!isFullLoader) {
                    this.ui.loader.toggleClass("list-hidden", !this._isListShown());
                }
            }

            if (show) {
                var loaderPermutation = (isFullLoader) ? Loader.PERMUTATION.D : Loader.PERMUTATION.G;
                var loaderElement = (isFullLoader) ? this.$el : this.ui.loader;
                this.loader = new Loader({
                    permutation: loaderPermutation,
                    el: loaderElement
                });
                this.loader.render();
            }
        },

        _addItem: function(item) {
            this.uiComponents.list.addItem(item);
            if (item.selected) {
                this.uiComponents.tagsContainer.addItem(_mapListObjToTagsContainerObj(item));
            }
        },

        _removeItem: function(itemId) {
            this.uiComponents.list.removeItem(itemId);
            this.uiComponents.tagsContainer.removeItem(itemId);
        },

        _select: function(itemId) {
            this.uiComponents.list.select(itemId);
            var listItem = this._getListItemById(itemId);
            this.uiComponents.tagsContainer.addItem(_mapListObjToTagsContainerObj(listItem));
        },

        _unselect: function(itemId) {
            this.uiComponents.list.unselect(itemId);
            this.uiComponents.tagsContainer.removeItem(itemId);
        },

        _unselectAll: function() {
            this.uiComponents.tagsContainer.clearItems();
            this.uiComponents.list.unselectAll();
        },

        _setItems: function(items) {
            this.uiComponents.list.setItems(items);
            this.uiComponents.tagsContainer.setItems(this._getSelectedItemsArrByList());
            // this.ui.list.find(".list-item-container").attr("tabindex", "-1").attr("role", "option");
            // this.ui.list.find(".list-group-items-container").attr("id", this.comboId);
            // this.ui.tagsContainer.attr("aria-owns", this.comboId);
            // this.ui.tagsContainer.find(".tag-input").attr("aria-controls", this.comboId);
            // this.ui.tagsContainer.find(".tag-input").attr("aria-activedescendant", "");
        },

        _setFocus: function() {
            return this.uiComponents.tagsContainer.setFocus();
        },

        _setBlur: function() {
            this.uiComponents.tagsContainer.setBlur();
        },

        _discardInput: function() {
            return this.uiComponents.tagsContainer.discardInput();
        },

        _getInputValue: function() {
            return this.uiComponents.tagsContainer.getInputValue();
        },

        _setInputValue: function(value) {
            this.uiComponents.tagsContainer.setInputValue(value);
        },

        _clearInputValue: function() {
            this.uiComponents.tagsContainer.clearInputValue();
        },

        _getSelectedItems: function() {
            var currentSelectedTags = this.uiComponents.tagsContainer.getItems();
            var currentSelectedIds = _.map(currentSelectedTags, function(tagObj) { return tagObj.id; });
            return currentSelectedIds;
        },

        _setEnabled: function(enabled) {
            this._showList(false);
            this.uiComponents.tagsContainer.setEnabled(enabled);
        },

        _setError: function(isError, errorMsg) {
            _.defer(_.bind(this.uiComponents.tagsContainer.setError, this.uiComponents.tagsContainer, isError, errorMsg));
        },

        _setInlineError: function(isError) {
            this.uiComponents.tagsContainer.setInlineError(isError);
        },

        _filterList: function(value) {
            this.logger.debug("Multiselect filter list", "Multiselect:_filterList", {value:value});
            var pageNumber = (value !== this.model.getFilterValue()) ? 1 : null;
            this.model.setFilterValue(value);
            this.uiComponents.list.filter(value, pageNumber);
        },

        _showList: function(show) {
            this.ui.list.toggleClass("hide", !show);
            this.ui.tagsContainer.attr("aria-expanded", show);
            // this.ui.list.find(".list-item-container").attr("tabindex", "-1").attr("role", "option");
            // this.ui.list.find(".list-group-items-container").attr("id", this.comboId);
            // this.ui.tagsContainer.attr("aria-owns", this.comboId);
            // this.ui.tagsContainer.find(".tag-input").attr("aria-controls", this.comboId);
        },

        _isListShown: function() {
            return !this.ui.list.hasClass("hide");
        },

        _getListItemById: function(itemId) {
            var listItems = this.uiComponents.list.getAllItems();
            var listItem = _.find(listItems, {id:itemId});

            return listItem;
        },

        _getListItemByValue: function(itemValue) {
            var listItems = this.uiComponents.list.getAllItems();
            var listItem = _.find(listItems, function(item) {
                return (item.value.toString().toLowerCase() === itemValue.toString().toLowerCase());
            });

            return listItem;
        },

        _getSelectedItemsArrByList: function() {
            var listItems = this.uiComponents.list.getAllItems();
            var selectedIds = this.uiComponents.list.getSelectedItems();

            var selectedObjArr = [];
            _.each(selectedIds, function(selectedId){
                var listItem = _.find(listItems, {id: selectedId});
                if (!_.isEmpty(listItem)) {
                    selectedObjArr.push(_mapListObjToTagsContainerObj(listItem));
                }
            });

            return selectedObjArr;
        },

        _onClose: function() {
            this.logger.info("Closing Multiselect", "Multiselect:_onClose");
            this._showLoader(false);
        }

        //</editor-fold>

    });

    function _mapListObjToTagsContainerObj(listObj) {
        return {
            id: listObj.id,
            value: listObj.value,
            subText: listObj.subText,
            iconClass: listObj.iconClass,
            closeable: _.has(listObj, "enabled") ? listObj.enabled : true
        };
    }

    function _initMultiselectModel(options) {
        var model = new MultiselectModel();

        if (_.has(options, "asyncFilter")) {
            model.setAsyncFilter(options.asyncFilter);
        }

        if (_.has(options, "asyncFilterMinChars")) {
            model.setAsyncFilterMinChars(options.asyncFilterMinChars);
        }

        if (_.has(options, "floating")) {
            model.setFloating(options.floating);
        }

        if (_.has(options, "trim")) {
            model.setTrim(options.trim);
        }

        return model;
    }

    function _initListOptions(options) {
        var listOptions = {};

        listOptions.paging = true;

        if (_.has(options, "items")) {
            listOptions.items = options.items;
        }

        if (_.has(options, "selectedItems")) {
            listOptions.selectedItems = options.selectedItems;
        }

        if (_.isObject(options.list)) {
            _.extend(listOptions, options.list);
        }

        return listOptions;
    }

    function _initTagsContainerOptions(options) {
        var tagsContainerOptions = {};

        if (_.has(options, "enabled")) {
            tagsContainerOptions.enabled = options.enabled;
        }

        if (_.isObject(options.tagsContainer)) {
            _.extend(tagsContainerOptions, options.tagsContainer);
        }

        return tagsContainerOptions;
    }

    Multiselect.TRIGGERING = TRIGGERING;
    Multiselect.PERMUTATION = PERMUTATION;

    return Multiselect;
});
